import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klik op de knop hieronder om uw betalingsgegevens te bekijken en te bevestigen.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'We werken samen met Stripe voor de betalingsverwerking. Stripe is het veiligste betalingsplatform dat door de grootste bedrijven wereldwijd wordt gebruikt.',
      form: {
        terms_acceptance: {
          label:
            'Door verder te gaan, gaat u akkoord met onze <FoodAmigosTerms>Serviceovereenkomst</FoodAmigosTerms> en de <StripeTerms>Stripe Connected Account-overeenkomst.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe heeft de onderstaande gegevens nog nodig of kon ze niet verifiëren:',
        errors: 'Fouten',
        awaiting_verification: 'Uw Stripe-account wordt geverifieerd',
        awaiting_verification_description:
          'We wachten tot Stripe uw bedrijf heeft geverifieerd. U kunt uw profiel in de tussentijd bekijken.',
        details_hint:
          'Stripe controleert namen, adressen en telefoonnummers aan de hand van officiële registers. Klopt er een niet, corrigeer deze dan onder Mijn info → Persoonlijke gegevens, waarna Stripe opnieuw controleert. Alles wat Stripe verder vraagt, kunt u aanvullen in uw Stripe-profiel.',
        requirements_hint:
          'Sommige hiervan zijn documenten, zoals uw ID: upload ze in de vorige stap, {{step}}, en kom dan hier terug.',
        requirements_hint_profile: 'Sommige hiervan zijn documenten, zoals uw ID: upload ze in uw Stripe-profiel.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Eigenaar',
          representative: 'Vertegenwoordiger',
          business: 'Bedrijf',
        },
        details: {
          first_name: 'Voornaam',
          last_name: 'Achternaam',
          email: 'E-mail',
          phone: 'Telefoonnummer',
          dob: 'Geboortedatum',
          id_number: 'ID-nummer',
          nationality: 'Nationaliteit',
          address: 'Straat en huisnummer',
          city: 'Plaats',
          postal_code: 'Postcode',
          state: 'Provincie',
          country: 'Land',
          id_document: 'ID-document',
          proof_of_address: 'Adresbewijs',
          job_title: 'Functietitel',
          business_name: 'Officiële bedrijfsnaam',
          tax_id: 'Btw-nummer',
          vat_id: 'VAT ID',
          registration_number: 'Registratienummer',
          website: 'Website',
          industry: 'Branche',
          product_description: 'Beschrijving van wat u verkoopt',
          support_phone: 'Telefoonnummer klantenservice',
          owners: 'Bevestiging van de eigenaren',
          directors: 'Bevestiging van de directieleden',
          executives: 'Bevestiging van de leidinggevenden',
          registration_document: 'Bedrijfsregistratiedocument',
          bank_account: 'Bankrekening voor uitbetalingen',
          business_type: 'Bedrijfstype',
          terms: "Aanvaarding van Stripe's voorwaarden",
          bank_account_proof: 'Bewijs van bankrekeningeigendom',
          tax_id_document: 'Document belastingnummer',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'We werken samen met Adyen voor betalingsverwerking. Adyen is een van de veiligste betalingsplatformen, gebruikt door de grootste bedrijven wereldwijd.',
    },
  },
  labels: {
    verified: 'Uw {{paymentGateway}}-account is geverifieerd',
    verified_description:
      'Verificatie voor {{paymentGateway}} is voltooid. U kunt uw profiel nog altijd beheren indien nodig.',
  },
  buttons: {
    proceed: 'Betalingsgegevens bevestigen',
    copy_link: 'Link kopiëren',
    back: 'Terug',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan, neem contact op met technische ondersteuning',
  },
};
